import { useCallback, useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";

export default function useAutoCycle(length, duration = 5500, paused = false) {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  const goTo = useCallback((next) => {
    setIndex(((next % length) + length) % length);
    setProgress(0);
  }, [length]);

  useEffect(() => {
    if (paused || reduceMotion || length < 2) {
      setProgress(paused || reduceMotion ? 0 : 1);
      return undefined;
    }

    let frame;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      setProgress(p);
      if (p >= 1) {
        setIndex((i) => (i + 1) % length);
        setProgress(0);
        return;
      }
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [index, paused, reduceMotion, length, duration]);

  return { index, setIndex: goTo, progress, reduceMotion };
}
